import axiosInstance from "../../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

const multipartHeaders = {
  "Content-Type": "multipart/form-data",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
};

const buildBrandFormData = (formData) => {
  const data = new FormData();
  if (formData.id) data.append("Id", formData.id);
  data.append("BrandName", formData.BrandName || "");
  data.append("BrandSlug", formData.BrandSlug || "");
  data.append("ShortDesc", formData.ShortDesc || "");
  data.append("FullDesc", formData.FullDesc || "");
  data.append("MetaTitle", formData.MetaTitle || "");
  data.append("MetaDesc", formData.MetaDesc || "");
  data.append("MetaKeywords", formData.MetaKeywords || "");
  if (formData.BrandImage instanceof File) {
    data.append("BrandImage", formData.BrandImage);
  }
  return data;
};

export const addBrand = async (formData) => {
  const response = await axiosInstance.post(
    "product-brand/add",
    buildBrandFormData(formData),
    { headers: multipartHeaders }
  );
  return response.data;
};

export const updateBrand = async (formData) => {
  const response = await axiosInstance.put(
    "product-brand/update",
    buildBrandFormData(formData),
    { headers: multipartHeaders }
  );
  return response.data;
};

export const deleteBrand = async (id) => {
  return await axiosInstance.delete(`product-brand/delete/${id}`, {
    headers,
  });
};

export const fetchBrandData = async (id) => {
  const response = await axiosInstance.get(
    `product-brand/GetProductBrand/${id}`,
    { headers }
  );
  return response.data.result;
};

export const getAllBrands = async () => {
  return await axiosInstance.get("product-brand/GetAllProductBrands", {
    headers,
  });
};

export const fetchBrandBySlug = async (slug) => {
  const response = await axiosInstance.get(
    `product-brand/GetProductBrandBySlug/${slug}`,
    { headers }
  );
  return response.data.result;
};